import React, {useState} from 'react';
import { addClient } from '../../api/Client';
import { useNavigate } from 'react-router-dom';

function ClientForm() {
    const history = useNavigate();
    const [clientData, setClientData] = useState({
        name : "",
        phone : "",
        email : "",
        address : "",
        city : "",
        country : "",
        type : "",
    })

      const {
        name ,
        phone ,
        email ,
        address ,
        city ,
        country ,
        type ,
      } = clientData;

      function handleName(e){
         setClientData({...clientData, name : e.target.value});
      }
      function handlePhone(e){
         setClientData({...clientData, phone : e.target.value});
      }
      function handleEmail(e){
        setClientData({...clientData, email : e.target.value});
      }
      function handleAddress(e){
        setClientData({...clientData, address : e.target.value});
      }
      function handleCity(e){
        setClientData({...clientData, city : e.target.value});
      }
      function handleCountry(e){
          setClientData({...clientData, country : e.target.value});
      }
      function handleType(e){
          setClientData({...clientData, type : e.target.value});
      }

      function handleSubmit(e){
         e.preventDefault();
         if(name.length < 1){
            e.preventDefault();
            return alert("Name is required");
         }
         if(phone.length < 1){
            e.preventDefault();
            return alert("Mobile number is required");
         }
         if(email.length < 1){
            e.preventDefault();
            return alert("Email address is required");
         }
         if(address.length < 1){
            e.preventDefault();
            return alert("Address is required");
         }
         if(city.length < 1){
            e.preventDefault();
            return alert("City is required");
         }
         if(country.length < 1){
            e.preventDefault();
            return alert("Country is required");
         }
         if(type.length < 1){
            e.preventDefault();
            return alert("Type is required");
         }

         addClient(clientData, (result) =>{
                 if(result.ok === 1){
                    alert(result.message);
                      return history("/ClientList");
                     
                 }
                 console.log(result)
                 return alert("Check your internet connections");
         })
      }

    return ( 
        <div className='container'>
            <div className='row justify-content-center'>
                <div className='row'>
                             <h5 className='m-4'>Add Client</h5>
                            <form method='post'>
                            <div className='row'>
                                <div className='col md-6'>
                                <div className='form-group'>
                                    <label>Client Name</label>
                                    <input type="text" name='name' onChange={handleName} className='form-control' placeholder='Client Name'/>
                                </div>
                                </div>
                                <div className='col md-6'>
                                <div className='form-group'>
                                    <label>Phone Number</label>
                                    <input type="text" name='phone' onChange={handlePhone} className='form-control' placeholder='Phone Number'/>
                                </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col md-6'>
                                <div className='form-group'>
                                    <label>Email</label>
                                    <input type="email" name='email' onChange={handleEmail} className='form-control' placeholder=' johdon@gmail.com'/>
                                </div>
                                </div>
                                <div className='col md-6'>
                                <div className='form-group'>
                                    <label>Address</label>
                                  <textarea className='form-control' name='address' onChange={handleAddress} placeholder='Adress'></textarea>
                                </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col md-6'>
                                <div className='form-group'>
                                    <label>City</label>
                                    <input type="text" className='form-control' name='city' onChange={handleCity} placeholder='City'/>
                                </div>
                                </div>
                                <div className='col md-6'>
                                <div className='form-group'>
                                    <label>Country</label>
                                    <input type="text" className='form-control' name='country' onChange={handleCountry} placeholder='Country'/>
                                </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col md-6'>
                                <div className='form-group'>
                                    <label>Type</label>
                                   <select className='form-control'  name='type' onChange={handleType}>
                                   <option value="">---</option>
                                    <option>Normal</option>
                                    <option>Standard</option>
                                    <option>Vip</option>
                                    <option>NIL</option>
                                    <option>Return</option>
                                   </select>
                                </div>
                                </div>
                                <div className='col md-6'></div>
                            </div>

                            <div className='row'>
                                <div className='col md-6'>
                                <div className='form-group mt-3'>
                                   <button className='btn btn-primary btn-md' onClick={handleSubmit}>Submit</button>
                                </div>
                                </div>
                                <div className='col md-6'></div>
                            </div>

                            </form>

                        </div>
                    </div>
                </div>
     );
}

export default ClientForm;